import { IPaginatedProductVariantShallow } from "@novel/shared/interfaces/ProductVariant";
import { NovelVendorSubReducer } from "@vendor-portal/redux/vendorTypedRedux";

export interface IVariantsReducerState extends IPaginatedProductVariantShallow {
    isLoading: boolean;
}

const initialState: IVariantsReducerState = {
    isLoading: true,
    totalCount: 0,
    pageSize: 0,
    pageNumber: 0,
    totalPages: 0,
    data: [],
};

export const variantsReducer: NovelVendorSubReducer<IVariantsReducerState> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case "LOADING_VARIANTS": {
            return {
                ...state,
                isLoading: true,
            };
        }

        case "ERROR_LOADING_VARIANTS": {
            return {
                ...state,
                isLoading: false,
            };
        }

        case "LOADED_VARIANTS": {
            return {
                ...state,
                totalCount: action.payload.paginatedVariants.totalCount,
                pageSize: action.payload.paginatedVariants.pageSize,
                pageNumber: action.payload.paginatedVariants.pageNumber,
                totalPages: action.payload.paginatedVariants.totalPages,
                data: action.payload.paginatedVariants.data,
                isLoading: false,
            };
        }

        default:
            return state;
    }
};
